import { Backdrop, CircularProgress, Paper } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

interface UnavailableProps {
  open: boolean;
}

export function Unavailable({ open }: UnavailableProps) {
  const { t } = useTranslation();

  // Check if we're on our own domain (dieter-datenschutz.de or localhost) to show branded version
  const isBrandedDomain =
    window.location.hostname.includes('dieter-datenschutz.de') || window.location.hostname.includes('localhost');

  return (
    <Backdrop open={open} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}>
      <Paper className="mx-4 max-w-md p-8 text-center flex flex-col items-center gap-5" elevation={10}>
        <CircularProgress size={48} />
        {isBrandedDomain ? (
          <Trans t={t} i18nKey="route.unavailable">
            <h2 className="text-xl sm:text-2xl font-semibold">
              Dieter ist gerade mit Wartungsarbeiten total beschäftigt.
            </h2>
            <p className="text-base sm:text-lg text-gray-600">Bald kümmert er sich wieder um deinen Datenschutz.</p>
            <p className="text-sm text-gray-400">
              Die Verbindung wird automatisch wiederhergestellt. Alle deine Daten sind gespeichert – es geht nichts
              verloren.
            </p>
          </Trans>
        ) : (
          <>
            <h2 className="text-xl sm:text-2xl font-semibold text-gray-900">Service vorübergehend nicht verfügbar</h2>
            <p className="text-base sm:text-lg text-gray-600">
              Wir führen gerade Wartungsarbeiten durch. Die Verbindung wird automatisch wiederhergestellt.
            </p>
            <p className="text-sm text-gray-400">Alle Ihre Daten sind gespeichert – es geht nichts verloren.</p>
          </>
        )}
      </Paper>
    </Backdrop>
  );
}
